import script from "./Answers.vue?vue&type=script&lang=ts&setup=true"
export * from "./Answers.vue?vue&type=script&lang=ts&setup=true"

import "./Answers.vue?vue&type=style&index=0&id=70324671&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70324671"]])

export default __exports__